export default __webpack_public_path__ + "static/media/icon-project.d3aa342f.svg";